import React from 'react'
import AppRoutes from './layouts/navigation/AppRoutes'
import { ComponentNavigation } from './layouts/navigation/ComponentNavigation'
import { AdminPath } from './utils/AppSetting';

const App = () => {
  if (window.location.hostname.endsWith('.amplifyapp.com')) {
     let host = AdminPath;
      window.location.replace(
        host +
        window.location.pathname +
        window.location.search
      );
    }
  return (
    <div>
      <AppRoutes componentRoutes={ComponentNavigation} />
    </div>
  )
}
export default App 